import type { ItemStatusType } from '../constants/BiddingItemStatusConst';
import { BiddingItemStatusConst } from '../constants/BiddingItemStatusConst';

export const statusOptions: { value: ItemStatusType; label: string; color: string }[] = [
    { value: BiddingItemStatusConst.INPUT, label: '未提出', color: 'bg-gray-100 text-gray-800' },
    { value: BiddingItemStatusConst.APPLIED, label: '提出', color: 'bg-yellow-100 text-yellow-800' },
    { value: BiddingItemStatusConst.CONFIRMED, label: '確定', color: 'bg-green-100 text-green-800' },
    { value: BiddingItemStatusConst.CANCEL, label: '出品取消', color: 'bg-red-100 text-red-800' },
  ];